'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2, _initialiseProps;

var _eventemitter = require('eventemitter3');

var _Event = require('./Event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The internal EventEmitter used by the application to communicate with the helpdesk UI hosting the application and the
 * own UI container implementation
 *
 * @class
 * @extends {EventEmitter}
 * @see https://github.com/primus/eventemitter3
 */
var AppEventEmitter = (_temp2 = _class = function (_EventEmitter) {
  (0, _inherits3.default)(AppEventEmitter, _EventEmitter);

  function AppEventEmitter() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AppEventEmitter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppEventEmitter.__proto__ || (0, _getPrototypeOf2.default)(AppEventEmitter)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AppEventEmitter, [{
    key: 'onInvoke',

    /**
     * Shortcut for on('invoke', handler). Registers an outgoing event handler.
     *
     * The `invoke` event delivers information about an outgoing event that needs dispatching to a 3rd party and as such
     * its arguments consists of the outgoing event name and its arguments.
     *
     * @param {OutgoingEventListener}  handler
     */
    value: function onInvoke(handler) {
      this.on('invoke', handler);
    }

    /**
     * Shortcut for emitAsync('invoke', ...args). Notifies the `invoke` listeners to handle the outgoing event `eventName`
     *
     * @public
     * @method
     *
     * @param {String} eventName an outgoing event name
     * @param {...*} args the arguments for the outgoing event name
     * @returns {Promise.<*, Error>}
     */

  }, {
    key: 'emitInvokeAsync',
    value: function emitInvokeAsync(eventName) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.emitAsync.apply(this, ['invoke', eventName].concat(args));
    }

    /**
     * Calls each listener registered for the event named `eventName` adding the resolve and reject callbacks of the
     * promise being returned.
     *
     * @public
     * @method
     * @param {string} eventName
     * @param [args]
     * @return {Promise.<*, Error>}
     */


    /**
     * Creates a closure with the same signature as `emit` which will emit the only after the listeners of the `beforeEventName` allow it.
     * Each `beforeEventName` listener will receive the same instance of {@link Event} which they can enable or disable
     *
     * @public
     * @method
     *
     * @param {String} beforeEventName
     * @param {function} onBeforeEmit a callback invoked before the event is emitted
     * @return function {AppEventEmitter~emit}
     */

  }]);
  return AppEventEmitter;
}(_eventemitter.EventEmitter), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.emitAsync = function (eventName) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    var executor = function executor(resolve, reject) {
      _this2.emit.apply(_this2, [eventName, resolve, reject].concat(args));
    };
    return new _promise2.default(executor);
  };

  this.emitCancelable = function (beforeEventName, onBeforeEmit) {
    return function (eventName) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      var event = new _Event.Event({ name: eventName, args: args });
      _this2.emit(beforeEventName, event);

      if (event.enabled) {
        onBeforeEmit();
        _this2.emit.apply(_this2, [eventName].concat(args));
      }
    };
  };
}, _temp2);
exports.default = AppEventEmitter;

/**
 * Event emitter function
 *
 * @callback AppEventEmitter~emit
 * @param {String} eventName
 * @param {...args} args
 */

/**
 * An outgoing event handler
 *
 * @callback OutgoingEventListener
 * @property {function} resolve a function which is called if the event's response is a success response
 * @property {function} reject a function which is called if the event's response is an error response
 * @property {string} event the event name
 * @property {*} data the event data
 */


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/AppEventEmitter.js
// module id = 310
// module chunks = 0